import React from "react";
import "../styles/formContainer.css";

export interface IForm {
  title: string;
  errorText: string;
  description: string;
  isDisabledButton: boolean;
  children: React.ReactNode;
  onSubmitForm(e: React.FormEvent<HTMLFormElement>): void;
}

const FormContainer: React.FC<IForm> = (props: IForm): React.JSX.Element => {
  const { title, errorText, description, isDisabledButton, children, onSubmitForm } = props;

  return (
    <form onSubmit={onSubmitForm} className="form" method="post">
      <h1 className="form__title">{title}</h1>
      <div className="form__fieldContainer">
        <p className="form__fieldLabel">{description}</p>
        {children}
      </div>
      <div className="form__errorContainer">{errorText ? <span data-testid="errorText">{errorText}</span> : null}</div>
      <button className="form__buttonSubmit" disabled={isDisabledButton}>
        Далее
      </button>
    </form>
  );
};

export default FormContainer;
